import React from "react";
import ReactCompareImage from "react-compare-image";
import terazniejszosc_1 from "assets/img/archive/6/terazniejszosc_2_1.jpg";
import terazniejszosc_2 from "assets/img/archive/6/terazniejszosc_2_2.jpg";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function ArchiveSixth({
  setPageTitle,
  setShowMenuToggler,
  setIsBackgroundMusic,
  setReturnLink,
}) {
  const { t } = useTranslation();
  useEffect(() => {
    setPageTitle(t("archive"));
    setShowMenuToggler(true);
    setIsBackgroundMusic(true);
    setReturnLink({ link: "/scene", from: "archive" });
  }, [setPageTitle, setShowMenuToggler, setReturnLink, setIsBackgroundMusic]);
  return (
    <div className="container-fluid px-4 py-5 vh-100">
      <div className="py-5 h-100 d-flex">
        <div className="mt-auto vh-75 w-100 d-flex justify-content-center align-items-center overflow-hidden position-relative">
          <span className="position-absolute start-0 top-0 z-index-11 px-3 py-1 bg-dark75 fs-18">
            {t("Mikołajow, 1970s")}
          </span>
          <span className="position-absolute end-0 top-0 z-index-11 px-3 py-1 bg-dark75 fs-18">
            {t("Mikołajów, 2021")}
          </span>
          <ReactCompareImage
            aspectRatio={"wider"}
            leftImage={terazniejszosc_2}
            rightImage={terazniejszosc_1}
          />
        </div>
      </div>
    </div>
  );
}
